var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMydeposits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 11.666C9.42793 11.666 11.6665 9.42744 11.6665 6.66602C11.6665 3.90459 9.42793 1.66602 6.6665 1.66602C3.90508 1.66602 1.6665 3.90459 1.6665 6.66602C1.6665 9.42744 3.90508 11.666 6.6665 11.666Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.075 8.64062C15.8628 8.93432 16.5638 9.4219 17.1132 10.0583C17.6625 10.6947 18.0426 11.4593 18.2182 12.2815C18.3937 13.1037 18.3591 13.9569 18.1176 14.7622C17.876 15.5674 17.4353 16.2988 16.8362 16.8886C16.2371 17.4785 15.499 17.9077 14.69 18.1366C13.8811 18.3656 13.0275 18.3869 12.2081 18.1985C11.3888 18.0101 10.6301 17.6182 10.0024 17.059C9.37465 16.4997 8.89806 15.7912 8.6167 14.999",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 5H6.66683V8.33333",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9249 11.5664L14.5082 12.1581L12.1582 14.5081",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMydeposits);
export default __webpack_public_path__ + "static/media/mydeposits.fd3284761cc45fb21b67c3dc8398e2ce.svg";
export { ForwardRef as ReactComponent };